import { render, staticRenderFns } from "./validate.vue?vue&type=template&id=1d1ec0ac"
import script from "./validate.vue?vue&type=script&lang=js"
export * from "./validate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports